export type CellVariant = 'default' | 'price' | 'commitment' | 'status' | 'blank'
export type StatusIcon = 'lightning' | 'check' | 'clock' | 'none'
export type CommitmentTerm = '12' | '24' | '36'

export interface TableCell {
  variant: CellVariant
  primaryText?: string | null
  secondaryText?: string | null
  link?: string | null
  hourlyPrice?: string | null
  monthlyPrice?: string | null
  commitment12?: string | null
  commitment24?: string | null
  commitment36?: string | null
  statusText?: string | null
  statusIcon?: StatusIcon | null
  id?: string | null
}

export interface TableRow {
  cells?: TableCell[] | null
  id?: string | null
}

export interface CellContent {
  primary: string
  secondary?: string
}

// Animation duration constant for train board flip effect
export const FLIP_ANIMATION_DURATION = 150
